import { StyleSheet } from '@react-pdf/renderer'

const theme = {
  colors: {
    blue900: '#1F2C4E',
    blue800: '#084B83',
    blue700: '#3D87C5',
    blue550: '#D8EFFF',
    grey800: '#303443',
    grey600: '#8DA6BF',
  },
  fontSize: {
    xxl: 50,
    xl: 24,
    l: 18,
    m: 14,
    s: 12,
    xs: 10,
  },
}

const stylesToShare = StyleSheet.create({
  pageBody: {
    display: 'flex',
    flexGrow: 1,
    alignSelf: 'stretch',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 24,
    paddingHorizontal: 35,
    paddingVertical: 65,
  },
  content: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexGrow: 1,
    alignSelf: 'stretch',
    gap: 24,
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    alignSelf: 'stretch',

    position: 'absolute',
    top: 25,
    right: 35,
  },
  preventiLogoHeader: {
    width: 100,
  },
  pageTitle: {
    color: theme.colors.blue800,
    fontFamily: 'Rubik',
    fontSize: theme.fontSize.xl,
    fontStyle: 'normal',
    fontWeight: 500,
  },
  pageNumber: {
    position: 'absolute',
    fontFamily: 'Rubik',
    fontSize: theme.fontSize.xs,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: theme.colors.grey600,
  },
  summaryContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: 8,
    alignSelf: 'stretch',
  },
  summaryTitle: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    paddingVertical: 4,
    paddingHorizontal: 4,
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'stretch',

    backgroundColor: theme.colors.blue550,
    color: theme.colors.blue900,
    fontFamily: 'Rubik',
    fontSize: theme.fontSize.m,
    fontStyle: 'normal',
    fontWeight: 500,
  },
  summaryBody: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    gap: 8,
  },
  summaryItem: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
  },
  summaryItemTitle: {
    width: '100%',
    color: theme.colors.blue900,
    fontFamily: 'Rubik',
    fontSize: theme.fontSize.s,
    fontStyle: 'normal',
    fontWeight: 500,
  },
  summaryItemText: {
    width: '100%',
    color: theme.colors.blue900,
    fontFamily: 'Rubik',
    fontSize: theme.fontSize.s,
    fontStyle: 'normal',
    paddingBottom: '12px',
    fontWeight: 400,
  },
  inlineBold: {
    fontWeight: 700,
  },
  inlineItalic: {
    fontStyle: 'italic',
  },
  horizontalSeparator: {
    alignSelf: 'stretch',
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: '#8DA6BF',
    marginVertical: 4,
  },
})
const stylesFrontPage = StyleSheet.create({
  frontPage: {
    paddingHorizontal: 0,
    paddingVertical: 65,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  pageTitle: {
    color: theme.colors.blue800,
    fontFamily: 'Rubik',
    fontSize: theme.fontSize.xxl,
    fontStyle: 'normal',
    fontWeight: 500,
  },
  preventiLogo: {
    width: 150,
  },
  frontPageIllustration: {
    width: 450,
  },
  date: {
    fontFamily: 'Rubik',
    fontSize: theme.fontSize.s,
    color: theme.colors.blue800,
    fontWeight: 500,
    fontStyle: 'normal',
  },
})
const stylesHealthRecordPage = StyleSheet.create({
  healthRecordPage: {
    height: '100%',
    alignSelf: 'stretch',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    paddingVertical: 65,
    paddingHorizontal: 35,
    paddingLeft: 80,
  },
  sideLine: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 80,
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'center',
    alignSelf: 'stretch',
    gap: 45,
    paddingVertical: 30,
    backgroundColor: theme.colors.blue800,
  },
  preventiLogoWhite: {
    width: 25,
  },
  blocksIcn: {
    width: 45,
  },
  main: {
    display: 'flex',
    flexGrow: 1,
    alignSelf: 'stretch',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 24,
    paddingLeft: 25,
  },
  patientNameWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    alignSelf: 'stretch',
    paddingVertical: 4,
    paddingHorizontal: 6,
    backgroundColor: theme.colors.blue550,
  },
  patientName: {
    color: theme.colors.blue900,
    fontFamily: 'Rubik',
    fontSize: theme.fontSize.l,
    fontStyle: 'normal',
    fontWeight: 500,
  },
  patientGeneralInfoBlock: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    alignContent: 'flex-start',
    rowGap: 4,
    alignSelf: 'stretch',
    flexWrap: 'wrap',
  },
  patientGeneralInfoElement: {
    width: 220,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 8,
  },
  patientGeneralInfoElementTitle: {
    color: theme.colors.blue700,
    fontFamily: 'Rubik',
    fontSize: theme.fontSize.s,
    fontStyle: 'normal',
    fontWeight: 500,
  },
  patientGeneralInfoElementValue: {
    color: theme.colors.grey800,
    fontFamily: 'Rubik',
    fontSize: theme.fontSize.s,
    fontStyle: 'normal',
    fontWeight: 400,
  },
  patientMedicalInfoBlock: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    alignSelf: 'stretch',
    gap: 12,
  },
  patientMedicalInfo: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 8,
    alignSelf: 'stretch',
  },
  patientMedicalInfoTitle: {
    width: 160,
    color: theme.colors.blue700,
    fontFamily: 'Rubik',
    fontSize: theme.fontSize.s,
    fontStyle: 'normal',
    fontWeight: 500,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    alignSelf: 'stretch',
  },
  patientMedicalInfoValuesArray: {
    maxWidth: 285,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    alignSelf: 'stretch',
    flexGrow: 1,
    gap: 4,
  },
  patientMedicalInfoValue: {
    width: '100%',
    color: theme.colors.grey800,
    fontFamily: 'Rubik',
    fontSize: theme.fontSize.s,
    fontStyle: 'normal',
    fontWeight: 400,
    alignSelf: 'stretch',
  },
  footer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    alignSelf: 'stretch',
    paddingBottom: 20,
    borderBottomColor: theme.colors.blue550,
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
  },
  footerElement: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
  },
  footerElementImg: {
    width: 16,
  },
  footerElementValue: {
    color: theme.colors.blue900,
    fontFamily: 'Rubik',
    fontSize: theme.fontSize.xs,
    fontStyle: 'normal',
    fontWeight: 400,
  },
})
const stylesInitialEvaluationPage = StyleSheet.create({
  healthElementBlock: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    alignSelf: 'stretch',
  },
  healthElement: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    alignSelf: 'stretch',
    paddingVertical: 12,
    gap: 18,
    borderBottomWidth: 1,
    borderBottomStyle: 'dashed',
    borderBottomColor: theme.colors.blue550,
  },
  healthElementIllustrations: {
    width: 220,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 18,
    justifyContent: 'flex-start',
    alignSelf: 'stretch',
  },
  healthElementIllustrationsIcn: {
    width: 25,
  },
  healthElementHeadings: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: 4,
    flex: '1 0 0',
    alignSelf: 'stretch',
  },
  healthElementTitle: {
    color: theme.colors.blue900,
    fontFamily: 'Rubik',
    fontSize: theme.fontSize.s,
    fontStyle: 'normal',
    fontWeight: 500,
  },
  healthElementProgressContainer: {
    width: 180,
    height: 7,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    alignSelf: 'stretch',
    borderRadius: 10,
    backgroundColor: theme.colors.blue550,
  },
  healthElementProgressLine: {
    width: 'auto',
    height: '100%',
    flex: '1 0 0',
    alignSelf: 'stretch',
    borderRadius: 10,
  },
  healthElementDivider: {
    width: 1,
    alignSelf: 'stretch',
    borderRightWidth: 1,
    borderRightStyle: 'dashed',
    borderRightColor: theme.colors.blue550,
  },
  healthElementDescriptionArray: {
    width: 268,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: 8,
    alignSelf: 'stretch',
  },
  healthElementDescriptionParagraph: {
    color: theme.colors.blue900,
    fontFamily: 'Rubik',
    fontSize: theme.fontSize.s,
    fontStyle: 'normal',
    fontWeight: 400,
  },
})
const stylesBackPage = StyleSheet.create({
  pageContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    alignSelf: 'stretch',
  },
  illustration: {
    width: '100%',
  },
  footerContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    alignSelf: 'stretch',
    paddingHorizontal: 35,
    paddingVertical: 65,
  },
  footerContentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: 24,
  },
  contactList: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: 8,
  },
  contactItem: {
    color: theme.colors.blue900,
    fontFamily: 'Rubik',
    fontSize: theme.fontSize.m,
    fontStyle: 'normal',
    fontWeight: 400,
  },
})
export { stylesToShare, stylesFrontPage, stylesHealthRecordPage, stylesInitialEvaluationPage, stylesBackPage }
